// removed by extract-text-webpack-plugin
module.exports = {"parent":"src-scripts-components-Tabs-__tabs___parent","tabsContainer":"src-scripts-components-Tabs-__tabs___tabsContainer","divider":"src-scripts-components-Tabs-__tabs___divider"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Tabs/tabs.css
// module id = 2745
// module chunks = 0